/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var curInventory = 1000000;
var leadTime = $('#leadTime');
var priceMin = '';
var priceMax = '';

document.addEventListener('variant:changed', function(event) {
	var variant = event.detail.variant;
	updateLeadTime(variant);
});

function updateLeadTime(variant) {
	setTimeout(function() {
		curInventory = jQuery('select[name=id] option:selected').data('inventory');
		if(variant.available == true) {
			if(curInventory <= 0) {
				leadTime.html('<p class="leadtime--orange">Backordered. Ships in 4-8 weeks.</p>');
			} else if(curInventory > 0 && curInventory < 3) {
				leadTime.html('<p class="leadtime--orange">Low Stock. Limited Quantities Available</p>');
			} else if(curInventory >= 3) {
				leadTime.html('<p class="leadtime--green">In Stock and Ready to Ship</p>');
			} else {
				leadTime.html('');
			}
		} else {
			leadTime.html('<p class="leadtime--orange">Backordered. Ships in 4-8 weeks.</p>');
		}
	}, 300);
}

if(isCollectionPage == false) {
	sessionStorage.removeItem('priceMin');
	sessionStorage.removeItem('priceMax');
	sessionStorage.removeItem('curCollection');
}

if(collectionHandle != '') {
	if(sessionStorage.getItem('curCollection') != collectionHandle) {
		sessionStorage.removeItem('priceMin');
		sessionStorage.removeItem('priceMax');
		sessionStorage.setItem('curCollection', collectionHandle);
	}
}

if (sessionStorage.getItem("priceMin") != null) {
	priceMin = sessionStorage.getItem("priceMin");
	$('.price-reset-button').show();
}
if (sessionStorage.getItem("priceMax") != null) {
	priceMax = sessionStorage.getItem("priceMax");
	$('.price-reset-button').show();
}

$('#pricemin').val(priceMin);
$('#pricemax').val(priceMax);

$('.ProductItem').each(function() {
	var productPrice = $(this).data('price');
	if(priceMin != '' || priceMax != '') {
		if(productPrice >= priceMin && productPrice <= priceMax) {
			$(this).parent().show();
		} else {
			$(this).parent().hide();
		}
	}
})

function filterPrices() {
	sessionStorage.setItem("priceMin", $('#pricemin').val());
	sessionStorage.setItem("priceMax", $('#pricemax').val());
	$.ajax({
		type: "POST",
		url: '/cart.js',
		data: {"attributes[pagination]": 100000},
		success: function(d){
			window.location.reload();
		},
		dataType: 'json'
	});
}

function clearPriceFilters() {
	sessionStorage.removeItem("priceMin");
	sessionStorage.removeItem("priceMax");
	$.ajax({
		type: "POST",
		url: '/cart.js',
		data: {"attributes[pagination]": 48},
		success: function(d){
			window.location.reload();
		},
		dataType: 'json'
	});
}

$('.CollectionInner__Sidebar .Collapsible--filters, .sidebar--marketing-library .Collapsible--filters').each(function() {
	$('.Collapsible__Button', this).on('click', function() {
      
  		if($(this).attr('aria-expanded') === "true") {
  			$(this).attr("aria-expanded","false");
  		} else {
  			$(this).attr("aria-expanded","true");
  		}
	});
});

function showAll() {
	$.ajax({
		type: "POST",
		url: '/cart.js',
		data: {"attributes[pagination]": 100000},
		success: function(d){
			sessionStorage.getItem('viewAll', true);
			window.location.reload();
		},
		dataType: 'json'
	});
}

$(window).on('load', function() {
	$.ajax({
		type: "POST",
		url: '/cart.js',
		data: {"attributes[pagination]": 48},
		dataType: 'json'
	});
});

// Register form
$('.register-toggle--new').click(function(e){
    $(this).addClass('register-toggle--active');
    $('.register-toggle--existing').removeClass('register-toggle--active');
    $('.register-content--new').toggleClass('register-content--open');
    $('.register-content--existing').removeClass('register-content--open');
});
$('.register-toggle--existing').click(function(e){
    $(this).addClass('register-toggle--active');
    $('.register-toggle--new').removeClass('register-toggle--active');
    $('.register-content--existing').toggleClass('register-content--open');
    $('.register-content--new').removeClass('register-content--open');
});

$('#newinfo .register-section-button--business-info').click(function(e){
    if($('#newinfo [required]:invalid').length == 0) {
       $('#newinfo').hide();
       $('#newbusinessinfo').show();

    } else {
        alert('Please fill in all required fields');
       return false;
    }
});
$('#newbusinessinfo .register-section-button--references').click(function(e){
    if($('#newbusinessinfo [required]:invalid').length == 0) {
       $('#newbusinessinfo').hide();
       $('#newreferences').show();

    } else {
        alert('Please fill in all required fields');
       return false;
    }
});
$('#newreferences .register-section-button--password').click(function(e){
    if($('#newreferences [required]:invalid').length == 0) {
       $('#newreferences').hide();
       $('#newpassword').show();

    } else {
        alert('Please fill in all required fields');
       return false;
    }
});
$('#newbusinessinfo .register-section-button--info').click(function(e){
    $('#newbusinessinfo').hide();
    $('#newinfo').show();
});
$('#newreferences .register-section-button--business-info').click(function(e){
    $('#newreferences').hide();
    $('#newbusinessinfo').show();
});
$('#newpassword .register-section-button--references').click(function(e){
    $('#newpassword').hide();
    $('#newreferences').show();
});

$('#existinginfo .register-section-button--password').click(function(e){
    if($('#existinginfo [required]:invalid').length == 0) {
       $('#existinginfo').hide();
       $('#existingpassword').show();

    } else {
        alert('Please fill in all required fields');
       return false;
    }
});
$('#existingpassword .register-section-button--info').click(function(e){
    $('#existingpassword').hide();
    $('#existinginfo').show();
});
